// The backend stores the name as unbounded TEXT, so this limit exists only in the UI.
export const PROJECT_NAME_MAX_LENGTH = 50;
